import { useTranslation } from 'react-i18next';

import { Icon404 } from 'icons';
import { Namespace } from 'enums';

import styles from './NotFoundPage.module.scss';

export const NotFoundPage = () => {
  const { t } = useTranslation(Namespace.NotFound);

  return (
    <div className={styles.notFoundBlock}>
      <Icon404 />
      <h2 className={styles.notFoundTitle}>{t('notFoundTitle')}</h2>
      <div className={styles.notFoundMessage}>{t('notFoundMessage')}</div>
    </div>
  );
};
